import React, { FC } from 'react';
import { useWixSdk } from '@wix/yoshi-flow-editor';

export const waitForWixSdkLoaded = (Component: FC) => {
  return () => {
    const { Wix } = useWixSdk();

    return Wix ? <Component /> : null;
  };
};
